import React, { useContext } from "react";
import { addGroup } from "../../../services/apiservices/groups";
import AuthContext from "../../../hooks/authContext";
import styles from "../employee.module.scss";
import { Input } from "../../../components/ui/input";
import { Button } from "../../../components/ui/button";
import { X } from "lucide-react";
import MultiSelectWithCheckbox from "../../../components/SelectField/MulitpleSelectNew";

const AddNewGroup = (props) => {
  const [newGroup, setNewGroup] = React.useState("");
  const [newGroupDescription, setNewGroupDescription] = React.useState("");
  const [newGroupType, setNewGroupType] = React.useState("");
  const [errors, setErrors] = React.useState("");
  const [selectedOptions, setSelectedOptions] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const auth = useContext(AuthContext);
  const { employeeList } = props;

  const employeeOptions = Array.isArray(employeeList)
    ? employeeList?.map((employee) => ({
        value: employee?.id,
        label: `${employee?.firstName} ${employee?.lastName}`,
        email: employee?.email,
        timeZone: employee?.timeZone
      }))
    : [];

  const companyId =
    auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;

  const GroupType = [
    { label: "Residential", value: "Residential" },
    { label: "Commercial", value: "Commercial" },
    { label: "Custom", value: "Custom" },
  ];

  const onAddGroup = async () => {
    if (newGroup !== "") {
      setIsLoading(true);
      await addGroup(
        {
          title: newGroup,
          description: newGroupDescription,
          companyId: companyId,
          type: newGroupType,
          employeeId: selectedOptions
        },
        (res) => {
          setIsLoading(false);
          props?.setIsOpen(false);
          props?.onSuccess && props?.onSuccess();
        },
        (resError) => {
          setIsLoading(false);
        }
      );
    } else {
      setIsLoading(false);
      setErrors({ newGroup: "Title is Required" });
    }
  };

  return (
    <div>
      {props?.isOpen && (
        <div className={`${styles.overlay}  ${!props?.isOpen ? styles.closing : ""}`}>
          <div
            className={`${styles.modal} dark:bg-[#1A1F2C] ${
              props?.isOpen ? styles.modalOpen : ""
            }`}
          >
            <div className={`${styles.header} d-flex flex-space-between`} >
                <div>
              <h2 className={`${styles.title} dark:text-white`}>Create New Group</h2>
              <p className={`${styles.description} dark:text-white`}>
                Add a new group to organize your team members.
              </p>
            </div>
              <div onClick={() => props?.setIsOpen(false)}> <X className="h-4 w-4 dark:text-white"/></div>
            </div>

            <div className="p-15">
              <div className="mb-15">
                <div>
                  <label htmlFor="name" className="text-sm font-medium dark:text-white">
                    Group Name
                  </label>
                  <Input
                    id="newGroup"
                    placeholder="Group Title"
                    onChange={(event) => {
                      setErrors({ newGroup: "" });
                      setNewGroup(event.target.value);
                    }}
                    value={newGroup ? newGroup : ""}
                    className="mt-8"
                  />
                </div>
                {typeof errors?.newGroup !== "undefined" &&
                  errors?.newGroup !== "" && (
                    <span className="mb-10 small error color-danger">
                      {errors?.newGroup}
                    </span>
                  )}
              </div>
              <div className="mb-15">
                <label htmlFor="name" className="text-sm font-medium dark:text-white">
                  Group Description
                </label>
                <Input
                  className="mt-8"
                  id="newGroupDescription"
                  placeholder="Group Description"
                  onChange={(event) => {
                    setNewGroupDescription(event.target.value);
                  }}
                  value={newGroupDescription ? newGroupDescription : ""}
                />
              </div>
              {/* <div className="mb-15">
                <label htmlFor="name" className="text-sm font-medium">
                  Group Type
                </label>
                <div className="mt-8">
                  <SingleSelectNew
                    id="groupType"
                    placeholder="Group Type"
                    options={GroupType}
                    onChange={(value) => {
                      setNewGroupType(value);
                    }}
                    value={newGroupType ? newGroupType : ""}
                  />
                </div>
              </div> */}
              <div>
                <label htmlFor="name" className="text-sm font-medium dark:text-white">
                  Group Members
                </label>
                <div className="mt-8">
                  <MultiSelectWithCheckbox
                    value={selectedOptions}
                    onChange={setSelectedOptions}
                    options={employeeOptions}
                    placeholder="Select Members"
                  />
                </div>
              </div>
              <div className="mv-12 d-flex flex-justify-flexend pv-10">
                <Button
                  className="mr-10"
                  variant={"outline"}
                  disabled={isLoading ? true : false}
                  onClick={() => props?.setIsOpen(false)}
                >
                  Cancel
                </Button>
                <Button
                  variant={"contained"}
                  onClick={onAddGroup}
                  className="bg-green-600 hover:bg-green-700 color-white"
                  disabled={isLoading ? true : false}
                >
                  {isLoading ? "Loading..." : "Add Group"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default AddNewGroup;
